import * as Yup from 'yup';

export enum DocumentSide {
  FRONT = 'front',
  BACK = 'back',
}

export enum DocumentType {
  CNI = 'CNI',
  PASSPORT = 'PASSPORT',
  LOCATION_MAP = 'Location_map',
  COMMERCIAL_REGISTER = 'commercial_register',
  OPERATING_LICENSE = 'operating_license',
  BILL_SUPPORT = 'bill',
}

export interface KycValues {
  expiryDate?: Date | null;
  documentNumber: string;
  doc_type_code: string;
  files: File | null;
  side: string|null;
  documentType: DocumentType;


}

export const initialKycValues: KycValues = {
  expiryDate: null,
  documentNumber: '',
  files: null, 
  doc_type_code: '',
  documentType: DocumentType.CNI,
  side: null,
};


// export const kycValidationSchema = Yup.object().shape({
//   expiryDate: Yup.date().when('documentType', {
//     is: (val: DocumentType) => val === DocumentType.CNI || val === DocumentType.PASSPORT,
//     then: (schema) => schema.required('Expiration date is required'),
//     otherwise: (schema) => schema.nullable(),
//   }),

//   documentNumber: Yup.string().when('documentType', {
//     is: (val: DocumentType) => val !== DocumentType.LOCATION_MAP,
//     then: (schema) => schema.required('Document number is required'),
//     otherwise: (schema) => schema.nullable(),
//   }),


// });



export const enterpriseKycValidationSchema = Yup.object({

  niu: Yup.mixed()
    .required("Le fichier d'identité est requis"),
  localisation: Yup.mixed().required("Le fichier d'identité est requis"),
  aml: Yup.mixed().nullable().required("Le fichier d'identité est requis")
});

export const enterpriseInitialKycValues = {
  niu: null,
  localisation: null,
  aml: null,
};




